enum NavigationColor {
  DARK = 'dark',
  LIGHT = 'light',
  BRAND = 'brand'
}

export default NavigationColor;
